import api from 'api/axiosInstance';
import { createApiUrl, getToken } from '../../util';
import { AxiosProgressEvent } from 'axios';

type PayloadType= Partial<DesignCustomMap> & {
	file: File;
}
export async function uploadCustomMap(
	uuid: string,
	payload: PayloadType,
	options?: { onUploadProgress?: (percent: number) => void }
) {
	const token = getToken('Authorization');

	const formData = new FormData();
	formData.append('file', payload.file);
	formData.append('x', String(payload.x));
	formData.append('y', String(payload.y));
	// formData.append('scaleX', String(payload.scaleX));
	// formData.append('scaleY', String(payload.scaleY));

	const { data } = await api.post(
		createApiUrl(`/design-custom-maps/upload/${uuid}`),
		formData,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
			onUploadProgress: (progressEvent: AxiosProgressEvent) => {
				if (progressEvent.total && options?.onUploadProgress) {
					const percentCompleted = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);

					options.onUploadProgress(percentCompleted);
				}
			}
		}
	);

	return data;
}

export async function update(
	id: number,
	payload: Partial<DesignCustomMap>
) {
	const token = getToken('Authorization');

	const { data } = await api.patch(
		createApiUrl(`/design-custom-maps/${id}`),
		payload,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);

	return data;
}

export async function bulkUpdate(
	payload: Partial<DesignCustomMap>[]
) {
	const token = getToken('Authorization');

	const { data } = await api.patch(
		createApiUrl('/design-custom-maps/bulk-update'),
		payload,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);

	return data;
}

export async function sort(
	uuid: string,
	payload: Array<{id: number, sortOrder: number}>
) {
	const token = getToken('Authorization');

	const { data } = await api.post(
		createApiUrl(`/design-custom-maps/sort/${uuid}`),
		payload,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);

	return data;
}

export async function deleteFile(id: number) {
	const token = getToken('Authorization');

	const { data } = await api.delete(
		createApiUrl(`/design-custom-maps/${id}`),
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);

	return data;
}
